(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-comparison-slider"] && !Shopify.designMode) return;
  try {
    
class ImageComparison {
  constructor(element) {
    this.element = element;
    this.clippedImage = this.element.querySelector('.image-comparison__clipped-image');
    this.handle = this.element.querySelector('.image-comparison__handle');
    this.images = this.element.querySelectorAll('.image-comparison__image');
    this.isDragging = false;
    this.currentPosition = 50;
    this.init();
    this.setPosition(this.currentPosition);
  }

  init() {
    this.handle.addEventListener('mousedown', this.startDragging.bind(this));
    window.addEventListener('mousemove', this.onDrag.bind(this));
    window.addEventListener('mouseup', this.stopDragging.bind(this));
    window.addEventListener('mouseleave', this.stopDragging.bind(this));

    this.handle.addEventListener('touchstart', this.startDragging.bind(this), { passive: false });
    window.addEventListener('touchmove', this.onDrag.bind(this), { passive: false });
    window.addEventListener('touchend', this.stopDragging.bind(this));

    this.images.forEach(img => {
      img.addEventListener('dragstart', e => e.preventDefault());
    });

    this.element.addEventListener('click', this.onClick.bind(this));
  }

  getPositionFromEvent(event) {
    const rect = this.element.getBoundingClientRect();
    const pageX = event.type.includes('touch') ? event.touches[0].pageX : event.pageX;
    const x = pageX - rect.left - window.scrollX;
    const position = (x / rect.width) * 100;
    return Math.max(0, Math.min(100, position));
  }

  setPosition(position) {
    this.currentPosition = position;
    requestAnimationFrame(() => {
      this.clippedImage.style.width = `${position}%`;
      this.handle.style.left = `${position}%`;
    });
  }

  startDragging(event) {
    if (event.type.includes('mouse')) {
      event.preventDefault();
    }
    this.isDragging = true;
    this.element.classList.add('dragging');
    document.body.style.cursor = 'col-resize';
  }

  stopDragging() {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.element.classList.remove('dragging');
    document.body.style.cursor = '';
  }

  onDrag(event) {
    if (!this.isDragging) return;
    event.preventDefault();
    const position = this.getPositionFromEvent(event);
    this.setPosition(position);
  }
  
  onClick(event) {
    if (event.target.closest('.image-comparison__handle-button')) {
      return;
    }
    const position = this.getPositionFromEvent(event);
    this.setPosition(position);
  }
}

function initializeImageComparisons() {
  const elements = document.querySelectorAll('[data-image-comparison]');
  elements.forEach(element => {
    if (!element.imageComparisonInstance) {
      element.imageComparisonInstance = new ImageComparison(element);
    }
  });
}

// Inicializa em diferentes eventos para garantir o funcionamento
document.addEventListener('DOMContentLoaded', initializeImageComparisons);
document.addEventListener('shopify:section:load', initializeImageComparisons);

// Inicializa caso já esteja tudo carregado
if (document.readyState === 'complete') {
  initializeImageComparisons();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-slide"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // PROTEÇÃO CONTRA REDEFINIÇÃO DE CLASSES
    if (customElements.get('ct-slide-show')) return;

    class CtSlideShow extends HTMLElement {
      constructor() {
        super();
        this.isInitialized = false;
        this.currentSlide = 0;
        this.slides = [];
        this.dots = [];
        this.autoplayTimer = null;
        this._autoplayStartTimer = null;
        this._autoplayReady = false;
        this._resizeFrame = null;
        this.isAnimating = false;
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      }

      connectedCallback() {
        // CORREÇÃO CRÍTICA:
        // Usamos setTimeout(..., 0) para mover a inicialização para o final da pilha de execução.
        // Isso garante que os elementos filhos (ct-slide-show-item) já tenham sido lidos pelo navegador.
        setTimeout(() => this.initialize(), 0);
      }

      initialize() {
        if (this.isInitialized) return;
        
        this.slides = Array.from(this.querySelectorAll('ct-slide-show-item'));
        
        // Verificação de segurança: Se não houver slides (ex: bug de renderização), aborta.
        if (this.slides.length === 0) return;

        this.transitionType = this.getAttribute('transition-type') || 'sweep';
        this.autoPlay = this.hasAttribute('auto-play');
        // Lê do data-attribute (sem getComputedStyle) p/ evitar reflow forçado na inicialização.
        const durationVar = parseFloat(this.dataset.autoplayDuration);
        this.autoplayDuration = (isNaN(durationVar) ? 5 : durationVar) * 1000;

        this.dotsContainer = this.querySelector('ct-page-dots');
        this.dots = this.dotsContainer ? Array.from(this.dotsContainer.querySelectorAll('.ct-slideshow__progress-bar')) : [];

        this.setAttribute('data-transition-type', this.transitionType);
        
        this.init();
        this.setupEventListeners();
        
        // Revela o slideshow suavemente após configurar tudo
        this.classList.add('is-ready');
        this.classList.add('is-initialized');
        
        // Ajuste de posição do texto
        this.positionContentBoxes();
        this._resizeHandler = () => {
          if (this._resizeFrame) return;
          this._resizeFrame = requestAnimationFrame(() => {
            this.positionContentBoxes();
            this._resizeFrame = null;
          });
        };
        window.addEventListener('resize', this._resizeHandler);
        
        if (this.autoPlay && this.slides.length > 1 && !this.prefersReducedMotion.matches) {
          this.scheduleAutoplay();
        }

        this.isInitialized = true;
      }

      disconnectedCallback() {
         if(this._resizeHandler) window.removeEventListener('resize', this._resizeHandler);
         if(this._visibilityHandler) document.removeEventListener('visibilitychange', this._visibilityHandler);
         if(this._resizeFrame) cancelAnimationFrame(this._resizeFrame);
         clearTimeout(this._autoplayStartTimer);
         clearInterval(this.autoplayTimer);
       }

      scheduleAutoplay() {
        const begin = () => {
          clearTimeout(this._autoplayStartTimer);
          this._autoplayStartTimer = setTimeout(() => {
            this._autoplayReady = true;
            if (!document.hidden && this.isConnected) this.startAutoplay();
          }, 12000);
        };

        if (document.readyState === 'complete') begin();
        else window.addEventListener('load', begin, { once: true });
      }

      init() {
        this.slides.forEach((slide, index) => {
          if (index === 0) {
            slide.setAttribute('aria-current', 'true');
            slide.style.zIndex = '2';
          } else {
            slide.removeAttribute('aria-current');
            slide.style.zIndex = '0';
          }
        });
      }

      setupEventListeners() {
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.goToSlide(index);
          });
        });
        
        this.addEventListener('mouseenter', () => this.pauseAutoplay());
        this.addEventListener('mouseleave', () => this.resumeAutoplay());
        this.addEventListener('focusin', () => this.pauseAutoplay());
        this.addEventListener('focusout', () => this.resumeAutoplay());

        this._visibilityHandler = () => {
          if (document.hidden) this.pauseAutoplay();
          else this.resumeAutoplay();
        };
        document.addEventListener('visibilitychange', this._visibilityHandler);
        
        let startX = 0;
        this.addEventListener('touchstart', e => startX = e.touches[0].clientX, {passive: true});
        this.addEventListener('touchend', e => {
          if (Math.abs(e.changedTouches[0].clientX - startX) > 50) {
            (e.changedTouches[0].clientX < startX) ? this.nextSlide() : this.previousSlide();
          }
        }, {passive: true});
      }

      async goToSlide(index) {
        if (this.isAnimating || index === this.currentSlide) return;
        this.isAnimating = true;

        if (this.autoPlay && this.autoplayTimer) {
           clearInterval(this.autoplayTimer);
           this.startAutoplay(); 
        }
        
        const current = this.slides[this.currentSlide];
        const next = this.slides[index];
        if (!current || !next) { this.isAnimating = false; return; }

        await this.hydrateSlideMedia(next);

        const direction = index > this.currentSlide ? 'next' : 'prev';
        
        this.updateDots(index);
        
        // Trava altura para transição suave se estiver em modo Auto
        if (this.classList.contains('ct-slideshow--auto')) {
             const h = this.offsetHeight;
             this.style.height = h + 'px';
             current.style.position = 'absolute'; 
             next.style.position = 'absolute';
        }
        
        // Prepara slides
        next.style.visibility = 'visible'; 
        next.style.display = 'flex';
        next.style.zIndex = '3'; 
        current.style.zIndex = '2'; 
        
        next.style.transition = 'none';
        current.style.transition = 'none';

        // Animação Sweep (Deslizar)
        if (this.transitionType === 'sweep') {
            const startX = direction === 'next' ? '100%' : '-100%';
            const endX = direction === 'next' ? '-100%' : '100%';
            next.style.transform = `translateX(${startX})`;
            next.style.opacity = '1';
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                next.style.transition = 'transform 0.8s cubic-bezier(0.4, 0, 0.2, 1)';
                current.style.transition = 'transform 0.8s cubic-bezier(0.4, 0, 0.2, 1)';
                next.style.transform = 'translateX(0)';
                current.style.transform = `translateX(${endX})`;
              });
            });
        } 
        // Animação Reveal (Revelar vertical)
        else if (this.transitionType === 'reveal') {
            next.style.zIndex = '1';
            next.style.opacity = '1';
            current.style.zIndex = '3';
            current.style.transition = 'transform 0.8s cubic-bezier(0.4, 0, 0.2, 1)';
            requestAnimationFrame(() => {
                current.style.transform = 'translateY(100%)';
            });
        } 
        // Animação Fade (Desvanecer)
        else { 
            next.style.opacity = '0';
            next.style.transition = 'opacity 0.6s ease';
            requestAnimationFrame(() => next.style.opacity = '1');
        }

        // Limpeza após transição
        setTimeout(() => {
           this.cleanupTransition(current, next);
        }, 850);
        
        this.currentSlide = index;
        this._setContentBoxPosition(next);
      }

      async hydrateSlideMedia(slide) {
        const template = slide.querySelector('template[data-slide-media]');
        if (!template) return;

        template.replaceWith(template.content.cloneNode(true));
        const images = Array.from(slide.querySelectorAll('img'));
        if (!images.length) return;

        const decoded = Promise.all(images.map((image) => {
          if (image.complete) return Promise.resolve();
          if (typeof image.decode === 'function') return image.decode().catch(() => {});
          return new Promise((resolve) => {
            image.addEventListener('load', resolve, { once: true });
            image.addEventListener('error', resolve, { once: true });
          });
        }));

        await Promise.race([
          decoded,
          new Promise((resolve) => setTimeout(resolve, 800))
        ]);
      }

      cleanupTransition(current, next) {
        if(current) {
          current.removeAttribute('aria-current');
          current.style.zIndex = '0';
          current.style.opacity = '0';
          current.style.visibility = 'hidden';
          current.style.transform = '';
          current.style.transition = '';
        }
        
        if(next) {
          next.setAttribute('aria-current', 'true');
          next.style.zIndex = '2';
          next.style.opacity = '1';
          next.style.transform = '';
          next.style.transition = '';
          
          if (this.classList.contains('ct-slideshow--auto')) {
             this.style.height = ''; 
             next.style.position = 'relative'; 
             if(current) current.style.position = 'absolute';
          }
        }
        
        this.isAnimating = false;
        if (this.dotsContainer && this.autoPlay) {
           this.animateDot(this.currentSlide);
        }
      }

      animateDot(index) {
         if (!this.dots[index]) return;
         const dot = this.dots[index];
         this.dots.forEach(d => {
             const f = d.querySelector('.ct-slideshow__progress-fill');
             if(f) f.remove();
         });
         
         const fill = document.createElement('div');
         fill.className = 'ct-slideshow__progress-fill';
         fill.style.width = '0';
         fill.style.transition = `width ${this.autoplayDuration}ms linear`;
         dot.appendChild(fill);
         requestAnimationFrame(() => { fill.style.width = '100%'; });
      }

      positionContentBoxes() {
        this.slides.forEach(slide => this._setContentBoxPosition(slide));
      }

      _setContentBoxPosition(slide) {
        const box = slide.querySelector('.content-box');
        if (!box) return;
        const pos = (box.dataset.textPosition || 'middle_center').split('_');
        const v = pos[0]; const h = pos[1];
        
        box.style.position = 'absolute';
        box.style.top = v === 'top' ? '2rem' : (v === 'bottom' ? 'auto' : '50%');
        box.style.bottom = v === 'bottom' ? '2rem' : 'auto';
        box.style.left = h === 'left' ? '2rem' : (h === 'right' ? 'auto' : '50%');
        box.style.right = h === 'right' ? '2rem' : 'auto';
        box.style.transform = `translate(${h === 'center' ? '-50%' : '0'}, ${v === 'middle' ? '-50%' : '0'})`;
        box.style.textAlign = h;
        if (window.innerWidth < 750) box.style.width = 'calc(100% - 2rem)';
      }

      updateDots(index) {
        this.dots.forEach((d, i) => {
          if (i === index) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      }
      
      nextSlide() { this.goToSlide((this.currentSlide + 1) % this.slides.length); }
      previousSlide() { this.goToSlide(this.currentSlide === 0 ? this.slides.length - 1 : this.currentSlide - 1); }
      
      startAutoplay() { 
        if (!this.autoPlay || this.prefersReducedMotion.matches || document.hidden) return;
        clearInterval(this.autoplayTimer);
        this.animateDot(this.currentSlide);
        this.autoplayTimer = setInterval(() => { 
            if (!this.isAnimating) this.nextSlide(); 
        }, this.autoplayDuration); 
      }
      
      pauseAutoplay() {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
      resumeAutoplay() {
        if (this.autoPlay && this._autoplayReady && this.isInitialized && !this.prefersReducedMotion.matches && !document.hidden) {
          this.startAutoplay();
        }
      }
    }
    
    // DEFINIÇÃO DOS COMPONENTES WEB
    customElements.define('ct-slide-show', CtSlideShow);
    customElements.define('ct-slide-show-item', class extends HTMLElement {});
    customElements.define('ct-page-dots', class extends HTMLElement {});
    
    if (!customElements.get('ct-split-lines')) {
      customElements.define('ct-split-lines', class extends HTMLElement {
          connectedCallback() {
              if (!this.hasAttribute('reveal')) return;
              const text = this.innerText;
              this.innerHTML = text.split(' ').map(w => `<span style="display:inline-block;overflow:hidden;vertical-align:top;"><span style="display:inline-block;transform:translateY(100%);transition:transform 0.6s cubic-bezier(0.2, 1, 0.3, 1);">${w}&nbsp;</span></span>`).join('');
              
              const obs = new MutationObserver(() => {
                  if (this.closest('[aria-current="true"]')) this.animate();
              });
              const slide = this.closest('ct-slide-show-item');
              if (slide) obs.observe(slide, {attributes:true});
              if (this.closest('[aria-current="true"]')) setTimeout(() => this.animate(), 200);
          }
          animate() {
              this.querySelectorAll('span > span').forEach((s, i) => setTimeout(() => s.style.transform = 'translateY(0)', i * 50));
          }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  let instances = {};

  class TimelineSlider {
    constructor(container) {
      this.container = container;
      this.sectionId = container.dataset.sectionId;
      this.slidesContainer = this.container.querySelector('.timeline-slides-container');
      this.slides = this.container.querySelectorAll('.timeline-slide');
      this.years = this.container.querySelectorAll('.timeline-year');
      this.nextButton = this.container.querySelector('.slider-button--next');
      this.prevButton = this.container.querySelector('.slider-button--prev');
      this.navWrapper = this.container.querySelector('.timeline-slider-navigation');
      this.highlightBar = this.container.querySelector('.timeline-highlight-bar');

      if (this.slides.length < 2) return;
      
      this.currentIndex = 0;
      this.autoplay = this.container.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.container.dataset.autoplaySpeed, 10);
      const transitionSpeed = this.container.dataset.transitionSpeed;
      this.container.style.setProperty('--transition-speed', transitionSpeed);

      this.init();
    }

    init() {
      this.navWrapper.style.display = 'block';
      this.bindEvents();
      this.updateSlider();
      if (this.autoplay) this.startAutoplay();
      
      this.resizeObserver = new ResizeObserver(() => this.updateHighlightBar());
      this.resizeObserver.observe(this.container);
    }

    bindEvents() {
      // Usar .bind(this) para manter a referência da função e poder removê-la depois
      this.next = this.next.bind(this);
      this.prev = this.prev.bind(this);
      this.goTo = this.goTo.bind(this);
      
      this.nextButton.addEventListener('click', this.next);
      this.prevButton.addEventListener('click', this.prev);
      
      this.yearClick = (e) => {
        const index = parseInt(e.currentTarget.dataset.yearIndex, 10);
        this.goTo(index);
      };
      this.years.forEach(year => year.addEventListener('click', this.yearClick));

      if (this.autoplay) {
        this.startAutoplay = this.startAutoplay.bind(this);
        this.stopAutoplay = this.stopAutoplay.bind(this);
        this.container.addEventListener('mouseenter', this.stopAutoplay);
        this.container.addEventListener('mouseleave', this.startAutoplay);
      }

      let touchstartX = 0;
      this.touchStartHandler = (e) => {
        touchstartX = e.changedTouches[0].screenX;
        if (this.autoplay) this.stopAutoplay();
      };
      this.touchEndHandler = (e) => {
        const touchendX = e.changedTouches[0].screenX;
        this.handleSwipe(touchstartX, touchendX);
        if (this.autoplay) this.startAutoplay();
      };
      this.slidesContainer.addEventListener('touchstart', this.touchStartHandler, { passive: true });
      this.slidesContainer.addEventListener('touchend', this.touchEndHandler, { passive: true });
    }
    
    destroy() {
      this.stopAutoplay();
      if (this.resizeObserver) this.resizeObserver.disconnect();

      this.nextButton.removeEventListener('click', this.next);
      this.prevButton.removeEventListener('click', this.prev);
      this.years.forEach(year => year.removeEventListener('click', this.yearClick));
      this.slidesContainer.removeEventListener('touchstart', this.touchStartHandler);
      this.slidesContainer.removeEventListener('touchend', this.touchEndHandler);
      
      if (this.autoplay) {
        this.container.removeEventListener('mouseenter', this.stopAutoplay);
        this.container.removeEventListener('mouseleave', this.startAutoplay);
      }
    }

    handleSwipe(start, end) {
      const threshold = 50;
      if (end < start - threshold) this.next();
      if (end > start + threshold) this.prev();
    }

    goTo(index) {
      if (index < 0) this.currentIndex = this.slides.length - 1;
      else if (index >= this.slides.length) this.currentIndex = 0;
      else this.currentIndex = index;
      this.updateSlider();
    }

    next() { this.goTo(this.currentIndex + 1); }
    prev() { this.goTo(this.currentIndex - 1); }

    updateSlider() {
      this.slidesContainer.style.transform = `translateX(-${this.currentIndex * 100}%)`;
      this.slides.forEach((s, i) => s.classList.toggle('is-active', i === this.currentIndex));
      this.years.forEach((y, i) => y.classList.toggle('is-active', i === this.currentIndex));
      this.updateHighlightBar();
    }

    updateHighlightBar() {
      if (!this.highlightBar || this.years.length < 1) return;

      const currentYear = this.years[this.currentIndex];
      const nextYear = this.years[this.currentIndex + 1];

      const startPos = currentYear.offsetLeft;
      let newWidth = 0;

      if (nextYear) {
        newWidth = nextYear.offsetLeft - startPos;
      } else {
        newWidth = currentYear.parentElement.offsetWidth - startPos;
      }
      
      this.highlightBar.style.left = `${startPos}px`;
      this.highlightBar.style.width = `${newWidth}px`;
    }

    startAutoplay() {
      if (!this.autoplay) return;
      this.stopAutoplay();
      this.autoplayInterval = setInterval(() => this.next(), this.autoplaySpeed);
    }

    stopAutoplay() {
      clearInterval(this.autoplayInterval);
    }
  }

  function initSlider(container) {
    if (!container) return;
    const sectionId = container.dataset.sectionId;
    // Limpa a instância anterior se ela existir
    if (instances[sectionId]) {
      instances[sectionId].destroy();
    }
    // Cria e armazena a nova instância
    instances[sectionId] = new TimelineSlider(container);
  }

  function destroySlider(container) {
    if (!container) return;
    const sectionId = container.dataset.sectionId;
    if (instances[sectionId]) {
      instances[sectionId].destroy();
      delete instances[sectionId];
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.timeline-slider-section').forEach(section => initSlider(section));
  });

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (section && section.classList.contains('timeline-slider-section')) {
      initSlider(section);
    }
  });
  
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target;
    if (section && section.classList.contains('timeline-slider-section')) {
      destroySlider(section);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
